import {
  ACTIVITY_ANALYTICS,
  BASE_PATH_ANALYTICS,
  BUTTONS_ANALYTICS,
  LINKS_ANALYTICS,
} from '@/constants/analytics'
import {
  createAnalyticsManifest,
  EventDispatcherConfig,
} from '@/services/analytics'
import { getPlatformScreenMode } from '@/utils/get-platform-screen-mode'

export const eventDispatcherConfig = (): EventDispatcherConfig =>
  ({
    config: {
      activity: ACTIVITY_ANALYTICS.ACCOUNT_VALUE_PROP,
      screenName: 'AccountValueProp',
      screenPath: BASE_PATH_ANALYTICS.PORTAL_OOBE,
    },
    defaultData: {
      screenMode: getPlatformScreenMode(),
    },
  }) as const

export const AppOobeValuePropPageAnalytics = createAnalyticsManifest(
  eventDispatcherConfig,
  ({ dispatcher }) => ({
    fireCreateAccountButtonClicked: () => {
      dispatcher.fireButtonClicked({
        controlName: BUTTONS_ANALYTICS.CREATE_ACCOUNT,
      })
    },
    fireSignInButtonClicked: () => {
      dispatcher.fireButtonClicked({
        controlName: BUTTONS_ANALYTICS.SIGN_IN,
      })
    },
    fireSkipButtonClicked: () => {
      dispatcher.fireButtonClicked({
        controlName: BUTTONS_ANALYTICS.SKIP,
      })
    },
    firePromoInfoLinkClicked: (href: string) => {
      dispatcher.fireHyperLinkClicked({
        controlName: LINKS_ANALYTICS.PROMO_INFO_LINK,
        controlDetail: href,
      })
    },
  }),
)
